import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useEffect, useState } from "react";

interface BannerProps {
  message: string;
  autoHideDuration?: number;
}

export default function Banner({ message, autoHideDuration = 10000 }: BannerProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, autoHideDuration);

    return () => clearTimeout(timer);
  }, [autoHideDuration]);

  if (!isVisible) return null;

  const bannerStyle = {
    position: "relative" as const,
    backgroundColor: "#FFF8E1",
    border: "1px solid #FFB74D",
    borderLeft: "4px solid #FF9800",
    borderRadius: "8px",
    padding: "16px 48px 16px 16px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
    "@media (max-width: 992px)": {
      padding: "14px 40px 14px 14px",
      gap: "10px",
    },
  };

  const closeButtonStyle = {
    position: "absolute" as const,
    top: "8px",
    right: "8px",
    padding: "4px",
    color: "#E65100",
    "&:hover": {
      backgroundColor: "rgba(255, 152, 0, 0.1)",
    },
  };

  const iconStyle = {
    color: "#FF9800",
    fontSize: "24px",
    marginTop: "2px",
    flexShrink: 0,
  };

  const messageStyle = {
    fontSize: "14px",
    lineHeight: "22px",
    color: "#3E2723",
    fontWeight: 400,
    "@media (max-width: 992px)": {
      fontSize: "13px",
      lineHeight: "20px",
    },
  };

  return (
    <Box sx={bannerStyle}>
      <WarningAmberIcon sx={iconStyle} />
      <Box sx={messageStyle}>{message}</Box>
      <IconButton
        size="small"
        onClick={() => setIsVisible(false)}
        sx={closeButtonStyle}
        aria-label="close banner"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
